import type {JobListProps} from './type';

/**
 * Custom React.memo comparator for JobList card variants.
 *
 * The list containers (JobFeed/V1, JobFeed/V2, ListWithTitle) recreate several
 * props on every render — inline `onJobClick={() => ...}` closures and a freshly
 * built `additionalInfo` array per row. A default shallow compare would therefore
 * treat every card as changed and re-render the entire list on any parent state
 * change (scroll, filter, store update), which is the dominant source of INP
 * input-delay on the listing pages.
 *
 * This comparator ignores function identity and the per-row `additionalInfo`
 * array (its contents are derived from `jobData`, so `jobData` identity covers it)
 * and compares only the data-bearing props that actually change the rendered card.
 */
const KEYS: (keyof JobListProps)[] = [
  'title',
  'refCode',
  'companyImgUrl',
  'fallbackCompanyUrl',
  'variant',
  'companyName',
  'isCompanyJob',
  'isPremiumJob',
  'showPremiumIcon',
  'showSaveIcon',
  'showThreeDotMenu',
  'showApplied',
  'isSaved',
  'location',
  'experiance',
  'noShadow',
  'noBorder',
  'jobData',
  'date',
  'isDetailCard',
  'showPosted',
  'redirectionLink',
  'prefCode',
  'whatFor',
  'jobPos',
  'showApplyButton',
];

export const jobListPropsAreEqual = (
  prev: JobListProps,
  next: JobListProps
): boolean => {
  for (const key of KEYS) {
    if (prev[key] !== next[key]) return false;
  }
  return true;
};

export default jobListPropsAreEqual;
